// src/RoleSelectionScreen.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './RoleSelectionScreen.css';
import logoUgoTaxi from './logo_ugo_taxi.png';
import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

const RoleSelectionScreen = () => {

  const navigate = useNavigate();
  const [driverStats, setDriverStats] = useState({
    online: 0,
    onRides: 0,
    available: 0,
    loading: true
  });

  useEffect(() => {
    const fetchDriverStats = async () => {
      try {
        const driversSnap = await getDocs(collection(db, 'drivers'));
        const drivers = driversSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        const online = drivers.filter(d => d.isOnline).length;
        const onRides = drivers.filter(d => d.isOnline && d.isOnJob).length;
        const available = drivers.filter(d => d.isOnline && !d.isOnJob).length;
        
        setDriverStats({
          online,
          onRides,
          available,
          loading: false
        });
      } catch (error) {
        console.error('Error fetching driver stats:', error);
        setDriverStats(prev => ({ ...prev, loading: false }));
      }
    };

    fetchDriverStats();
    
    // Refresh stats every 30 seconds
    const interval = setInterval(fetchDriverStats, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const getStatusColor = () => {
    if (driverStats.loading) return '#6c757d';
    if (driverStats.available > 0) return '#28a745';
    if (driverStats.online > 0) return '#ffc107';
    return '#dc3545';
  };

  const getStatusText = () => {
    if (driverStats.loading) return 'Loading driver status...';
    if (driverStats.available > 0) return `${driverStats.available} driver${driverStats.available === 1 ? '' : 's'} available now`;
    if (driverStats.online > 0) return `${driverStats.online} driver${driverStats.online === 1 ? '' : 's'} online (all busy)`;
    return 'No drivers online right now.';
  };

  return (
    <div className="container">
      <div className="logo">
        <img src={logoUgoTaxi} alt="UGO Logo" />
      </div>

      {/* Driver Status Info Bar */}
      <div 
        className="driver-status-bar"
        style={{
          backgroundColor: getStatusColor(),
          color: 'white',
          padding: '12px 20px',
          borderRadius: '8px',
          margin: '20px 0',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'bold',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          transition: 'background-color 0.3s ease'
        }}
      >
        <div style={{ marginBottom: '4px' }}>
          🚖 {getStatusText()}
        </div>
        {!driverStats.loading && (
          <div style={{ fontSize: '14px', opacity: 0.9 }}>
             Online: {driverStats.online} | On Rides: {driverStats.onRides}
          </div>
        )}
      </div>

      <div className="role-buttons">
        <button className="button" onClick={() => navigate('/riderLogin')}>
          Login as Rider
        </button>
        <button className="button" onClick={() => navigate('/guestLogin')}>
          Login as Guest
        </button>
        <button className="button" onClick={() => navigate('/RiderRegisterScreen')}>
          Create an Account
        </button>
      </div>

      <div className="footer-text">
        Be safe, Be sure, Always use a licensed Taxi!
      </div>

      {/* iOS App Store Section */}
      <div style={{ 
        marginTop: '30px', 
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '12px',
        textAlign: 'center',
        border: '1px solid #e9ecef'
      }}>
        <div style={{ 
          fontSize: '18px', 
          fontWeight: 'bold', 
          color: '#333',
          marginBottom: '10px'
        }}>
          📱 Now Available on iOS!
        </div>
        <div style={{ 
          fontSize: '14px', 
          color: '#666',
          marginBottom: '15px'
        }}>
          Download our mobile app for the best booking experience
        </div>
        <a 
          href="https://apps.apple.com/gb/app/u-go-taxi-beverley/id6751916677" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <img 
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="Download on the App Store"
            style={{ 
              height: '40px',
              cursor: 'pointer',
              transition: 'transform 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1.0)'}
          />
        </a>
      </div>
      
      <div style={{ 
        marginTop: '20px', 
        textAlign: 'center' 
      }}>
        <button 
          onClick={() => navigate('/admin')}
          style={{
            background: 'none',
            border: 'none',
            color: '#6c757d',
            fontSize: '12px',
            cursor: 'pointer',
            textDecoration: 'underline',
            padding: '5px'
          }}
        >
          🔧 Admin Panel
        </button>
      </div>
    </div>
  );
};

export default RoleSelectionScreen;